var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.hideCompletly
    ? _c(
        "w-list-item",
        { staticClass: "root", style: { flexDirection: "column" } },
        [
          _vm.showTitle
            ? _c(
                "div",
                { staticClass: "w-list-title" },
                [
                  _c(
                    "w-link",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          _vm.open = !_vm.open
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: _vm.openIcon } }),
                      _vm._v(" " + _vm._s(_vm.fullName)),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.open
            ? _c(
                "w-list",
                [
                  _vm._l(_vm.fields, function (item) {
                    return _c("app-column-select-edit-node-item", {
                      key: item.path,
                      attrs: {
                        field: item,
                        path: item.path,
                        model: _vm.model,
                        "filterable-only": _vm.filterableOnly,
                        name: item.name,
                        active: item.active,
                        browse: _vm.browse,
                        favourites: _vm.favourites,
                        "show-favourites": _vm.showFavourites,
                        "can-favourite": _vm.canFavourite,
                        "full-name": _vm.fullName,
                        "filter-text": _vm.filterText,
                        "preview-value": _vm.previewValue,
                        "is-initial-render": _vm.isInitialRender,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onFieldClick(item.path, item.name)
                        },
                      },
                    })
                  }),
                  _vm._l(_vm.namedFilters, function (item) {
                    return _c("app-column-select-edit-node-item", {
                      key: item.value,
                      attrs: {
                        path: item.value,
                        "filterable-only": _vm.filterableOnly,
                        name: item.text,
                        active: _vm.isNamedFilterActive(item.value),
                        browse: _vm.browse,
                        favourites: _vm.favourites,
                        "show-favourites": _vm.showFavourites,
                        "can-favourite": _vm.canFavourite,
                        "full-name": _vm.fullName,
                        "filter-text": _vm.filterText,
                        "is-initial-render": _vm.isInitialRender,
                      },
                      on: {
                        click: function ($event) {
                          _vm.onFieldClick(item.value, item.text.toString())
                        },
                      },
                    })
                  }),
                  _vm._l(_vm.subFields, function (item) {
                    return _c("app-column-select-edit-node", {
                      key: item.path,
                      attrs: {
                        model: item.model,
                        name: item.name,
                        "full-path": item.path,
                        depth: _vm.depth + 1,
                        "ignored-paths": _vm.ignoredPaths,
                        "is-server-column": _vm.isServerColumn,
                        "filter-text": _vm.filterText,
                        "full-name": item.fullName,
                        "filterable-only": _vm.filterableOnly,
                        "selected-value": _vm.selectedValue,
                        "nummeric-only": _vm.nummericOnly,
                        browse: _vm.browse,
                        favourites: _vm.favourites,
                        "show-favourites": _vm.showFavourites,
                        "can-favourite": _vm.canFavourite,
                        "preview-value": _vm.previewValue,
                        "is-initial-render": _vm.isInitialRender,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onField($event)
                        },
                        name: function ($event) {
                          return _vm.onName($event)
                        },
                      },
                    })
                  }),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }